var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from "vue-property-decorator";
import axios from "axios";
import { parseJSON, isPast } from "date-fns";
let JobOverviewList = class JobOverviewList extends Vue {
    id = this.$route.params.id;
    color = "#F44336";
    text = "";
    snackbar = false;
    material = [];
    workstep = [];
    jobs = [];
    date = "";
    timeout = -1;
    index = 0;
    warehourse = false;
    headers = [
        { text: 'Format', value: 'format' },
        { text: 'Material', value: 'material' },
        { text: 'Dicke', value: 'thickness' },
        { text: 'Anzahl', value: 'quantity' },
        { text: 'Notizen', value: 'note' },
        { text: 'Lieferdatum', value: 'delivery_date' },
        { text: 'Waren Ankunftsdatum', value: 'receipt_date' },
        { text: 'auf lager', value: 'goods_available' },
    ];
    workheaders = [
        { text: 'Name', value: 'name' },
        { text: 'Beschreibung', value: 'description' },
        { text: 'Arbeitsschritt', value: 'work_type' },
        { text: 'Datum', value: 'date' },
        { text: 'Uhr zeit', value: 'time' },
        { text: 'Kontrolle', value: 'control' },
    ];
    jobHeaders = [
        { text: 'Auftragsnummer', align: 'start', value: 'id' },
        { text: 'Ordernummer', value: 'order_nr', },
        { text: 'Artikel', value: 'article' },
        { text: 'Kunde', value: 'customer' },
        { text: 'Lieferdatum', value: 'delivery_date' },
        { text: 'Endkontrolle', value: 'final_control' },
        { text: 'index', value: 'index' },
        { text: 'Notiz', value: 'note' },
    ];
    getMW() {
        this.getJobList();
        this.getmaterial();
        this.getWorkstep();
    }
    isPast(item) {
        return isPast(parseJSON(item));
    }
    getJobList() {
        axios.get('/api/jobs/' + this.id).then((response) => {
            this.jobs[0] = response.data.data;
        });
        return this.jobs;
    }
    getmaterial() {
        axios.get('/api/assigment/' + this.id + '/job').then((response) => {
            this.material = response.data.data;
        });
        return this.material;
    }
    getWorkstep() {
        axios.get('/api/worklog/' + this.id + '/job').then((response) => {
            this.workstep = response.data.data;
        });
        return this.workstep;
    }
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.$store.state.monitor = false;
            this.getMW();
        }
        else {
            this.$store.commit('logout');
        }
    }
};
JobOverviewList = __decorate([
    Component({
        name: "JobOverviewList",
    })
], JobOverviewList);
export default JobOverviewList;
